import { StudentTerm } from './../builders/student_term_builder';
import { IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';

export interface IStudentTermsDatasource extends IDatasource<StudentTerm> {}

angular
  .module('capability-ng-user-app')
  .factory('ngStudentTermsDatasource', function(
    ngStudentTermBuilder: typeof StudentTerm,
    Datasource: IDatasourceConstructor<StudentTerm>
  ): IStudentTermsDatasource {
    return new Datasource({
      builderType: ngStudentTermBuilder
    });
  });



// WEBPACK FOOTER //
// ./app/lib/user_app/datasources/student_terms_datasource.ts